import defineService from "./defineService";


export const getVouchers = defineService(
  'get', 'api/v1/vouchers/'
);

export const getVoucher = defineService(
  'get', 'api/v1/vouchers/:id/'
);

export const postVoucher = defineService(
  'post', 'api/v1/vouchers/'
);



// WEBPACK FOOTER //
// ./src/services/vouchers.js